<template>
  <SettingsLayout>
    <Head :title="`${page_name} - Grundeinstellungen`" />

    <template #breadcrumb>{{ page_name }}</template>
    <template #controls>
      <HeaderLink class="mr-3" href="/" type="close">Schließen</HeaderLink>
      <HeaderButton @click="submitForm()">Speichern</HeaderButton>
    </template>
    <Heading title="" />

    <p class="max-w-2xl text-sm text-oteoText">
      Hier können Sie eine Farbe für das Design von oteo auswählen. Buttons,
      Termine etc. werden dann in einer anderen Farbe dargestellt.
    </p>

    <div class="mt-8">
      <Label> Farbschema Spitta </Label>
      <div class="flex items-center">
        <input class="mr-8" type="radio" v-model="form.theme" value="spitta" />
        <div class="flex w-48 h-16">
          <div class="flex-1 bg-[#006eb4] rounded-tl-md rounded-bl-md"></div>
          <div class="flex-1 bg-[#c0d9ea]"></div>
          <div class="flex-1 bg-[#dcebf5] rounded-tr-md rounded-br-md"></div>
        </div>
      </div>
    </div>
    <div class="mt-8">
      <Label> Farbschema dios </Label>
      <div class="flex items-center">
        <input
          class="mr-8 appearance-none"
          type="radio"
          v-model="form.theme"
          value="dios"
        />
        <div class="flex w-48 h-16">
          <div class="flex-1 bg-[#0f6058] rounded-tl-md rounded-bl-md"></div>
          <div class="flex-1 bg-[#a3e2d1]"></div>
          <div class="flex-1 bg-[#c2efe3] rounded-tr-md rounded-br-md"></div>
        </div>
      </div>
    </div>
    <div class="mt-8">
      <Label> Farbschema Rot </Label>
      <div class="flex items-center">
        <input class="mr-8" type="radio" v-model="form.theme" value="red" />
        <div class="flex w-48 h-16">
          <div class="flex-1 bg-[#d32d2d] rounded-tl-md rounded-bl-md"></div>
          <div class="flex-1 bg-[#fdc5c5]"></div>
          <div class="flex-1 bg-[#ffe6e6] rounded-tr-md rounded-br-md"></div>
        </div>
      </div>
    </div>
    <div class="mt-8">
      <Label> Farbschema Gelb </Label>
      <div class="flex items-center">
        <input class="mr-8" type="radio" v-model="form.theme" value="yellow" />
        <div class="flex w-48 h-16">
          <div class="flex-1 bg-[#ff9317] rounded-tl-md rounded-bl-md"></div>
          <div class="flex-1 bg-[#ffd7a7]"></div>
          <div class="flex-1 bg-[#ffefdb] rounded-tr-md rounded-br-md"></div>
        </div>
      </div>
    </div>
  </SettingsLayout>
</template>

<script setup>
const page_name = "Design";
const form = useForm({
  theme: usePage().props.value.theme ?? "spitta",
});

watch(form, ({ theme }) => {
  const themeWrapper = document.getElementById("theme-wrapper");
  themeWrapper.classList.remove(
    "theme-spitta",
    "theme-dios",
    "theme-red",
    "theme-yellow"
  );
  themeWrapper.classList.add("theme-" + theme);
});

function submitForm() {
  form.put("/design");
}

import { usePage } from "@inertiajs/inertia-vue3";
import SettingsLayout from "@/Layouts/Settings.vue";
import Input from "@/Components/Settings/Input.vue";
import Label from "@/Components/Settings/Label.vue";
import HeaderLink from "@/Components/Settings/HeaderLink.vue";
import HeaderButton from "@/Components/Settings/HeaderButton.vue";
import Heading from "@/Components/Settings/Heading.vue";
import { Head, useForm } from "@inertiajs/inertia-vue3";
import { ref, watch } from "vue";
</script>